module.exports = __webpack_public_path__ + "img/background.39a4d2db.jpg";